// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"179":"2d8bd7cf","289":"f2290289","343":"46367d71","453":"8de653e7","764":"56b0ff6c","836":"1eca7e3f","932":"5e0eb38f"}[chunkId] + ".chunk.js";
};